module.exports = __webpack_public_path__ + "assets/left-side097f2674.png";


//////////////////
// WEBPACK FOOTER
// ./src/views/login/images/left-side.png
// module id = 661
// module chunks = 23